import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Suppliers/Suppliers/tables";
import headers from "../../../../Data/Tables/Suppliers/Suppliers/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_suppliers } from "../../../../Controllers/Suppliers";
import FeatureLockWrapper from "../../../../Componets/FeatureLocksWrapper";
import UserCurrency from "../../../../Componets/UserCurrency";

const SuppliersTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const [summary, setSummary] = useState({
    totalOutstanding: 0,
    totalPurchases: 0,
    totalAmount: 0,
    overdueAmount: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      catalog: headerdata?.catalog,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};

    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      catalog: headerdata?.catalog,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        catalog: tabledata?.catalog,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const suppliers = await get_all_suppliers(params);

      const suppliersData = suppliers?.data?.data || [];

      if (suppliers?.status) {
        let data = [];

        const unlocked = await FeatureLockWrapper.isFeatureUnlocked(
          "supplier_outstanding_report",
        );

        suppliers?.data?.data?.map((value, index) => {
          if (unlocked) {
            data?.push({
              path: `/app/suppliers/view/${value?._id}`,
              Name: value?.name,
              Email: value?.email,
              Phone: value?.phone,
              "Total Debit":value?.totalDebit,
              "Total Credit":value?.totalCredit,
              "Current Balance":value?.currentBalance,
              Status: <Status status={value?.status} />,
              Action: (
                <ActionButton
                  edit={`/app/suppliers/edit/${value?._id}`}
                  id={value?._id}
                  api="delete-supplier"
                  actiondata={actiondata}
                  headers={header}
                />
              ),
            });
          } else {
            data?.push({
              path: {
                featureKey: "supplier_outstanding_report",
                name: "Supplier Outstanding Report",
                message:
                  "Access to this report is Locked. Please unlock Supplier Outstanding Report Feature to proceed.",
              },
              Name: value?.name,
              Email: value?.email,
              Phone: value?.phone,
              Status: <Status status={value?.status} />,
              Action: (
                <ActionButton
                  edit={`/app/suppliers/edit/${value?._id}`}
                  id={value?._id}
                  api="delete-supplier"
                  actiondata={actiondata}
                  headers={header}
                />
              ),
            });
          }
        });

        const summaryData = suppliersData.reduce(
          (acc, supplier) => {
            acc.totalOutstanding += supplier.totalOutstanding || 0;
            acc.totalPurchases += supplier.totalPurchases || 0;
            acc.totalAmount += supplier.totalAmount || 0;
            acc.overdueAmount += supplier.overdueAmount || 0;
            return acc;
          },
          {
            totalOutstanding: 0,
            totalPurchases: 0,
            totalAmount: 0,
            overdueAmount: 0,
          },
        );

        setSummary(summaryData);

        setPagination({
          currentPage: suppliers?.data?.currentPage,
          totalCount: suppliers?.data?.totalCount,
          totalPages: suppliers?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(suppliers?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
       <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-2 pt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              <UserCurrency />  {summary.totalOutstanding.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Purchases</h3>
            <p className=" text-green-600">{summary.totalPurchases}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Amount</h3>
            <p className=" text-green-600">
              <UserCurrency />  {summary.totalAmount.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              <UserCurrency />  {summary.overdueAmount.toFixed(3)}
            </p>
          </div>
        </div>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default SuppliersTable;
